import LogoComponent from "../LogoComponent";
import "./style.scss";
import {
  Link
} from "react-router-dom";
import React, { lazy, Suspense, useEffect } from "react";
import { useContext, useState } from "react";
import WalletSettings from "components/Secondary/WalletSettings";
import useWindowDimensions from "helpers/screen";
import {ReactComponent as MenuIcon} from "assets/icons/menu.svg";
import {ReactComponent as CloseIcon} from "assets/icons/close.svg";
import {ReactComponent as Logo} from "../../../assets/images/logo.svg";
import { useHistory } from 'react-router-dom'
import ConnectWallet from "components/Secondary/ConnectWallet";
import DropdownIcon from "assets/icons/dropdown.svg";
import CreateMarketPopup from "components/Secondary/CreateMarketPopup";
import {ReactComponent as SettingsIcon} from "assets/icons/settings.svg";
import ButtonSelector from "components/Secondary/ButtonSelector";
import { useDispatch, useSelector } from "react-redux";
import { setTheme } from "redux/state";
import {ReactComponent as LightIcon} from "assets/icons/light.svg";
import {ReactComponent as DarkIcon} from "assets/icons/dark.svg";
import {ReactComponent as TerminalIcon} from "assets/icons/terminal.svg";
import PhoenixImage from "assets/images/phoenix.jpeg";
import OpenbookImage from "assets/images/openbook.svg";

const menuItems = [
  // {
  //   url: "/markets",
  //   title: "Markets"
  // },
  {
    url: "/",
    title: "Trade"
  },
]
const Header = () => {
  const state = useSelector((state) => state.storage);
  const dispatch = useDispatch();
  const {width} = useWindowDimensions();
  const [burgerMenuOpened, setBurgerMenuOpened] = useState(false);
  const [moreDropdown, setMoreDropdown] = useState(false);
  const [createMarketOpened, setCreateMarketOpened] = useState(false);
  const [settingsDropdown, setSettingsDropdown] = useState(false);
  const [themeWheel, setThemeWheel] = useState(["light","dark","terminal"]);

  const history = useHistory() 

  function switchTheme(id=undefined) {
    let nextIndex = id;
    dispatch(setTheme(themeWheel[nextIndex]));
    const body = document.querySelector("body");
    body.dataset.theme = themeWheel[nextIndex];
    window.localStorage.setItem("theme",themeWheel[nextIndex]);

  }

  // Desktop Version
  if(width > 900)
  return <>
    <div className="headerWrapper">
      <div className="side">
        <Link to={"/"}><Logo className="logo" fill={"var(--gray900"} height={16}/></Link>
        <hr className="separator" style={{marginRight:"0.6rem"}}/>
        <Link to={"/wallet"} className={history.location.pathname === "/wallet" ? "menuContainer menuItem _selected" : "menuContainer menuItem"}>
          Wallet
        </Link>
        <hr className="separator" style={{marginLeft:"0.6rem", marginRight:"0.6rem"}}/>
        <div className="menuContainer">
          {
            menuItems.map((item, i) => {
              return <Link to={item.url} key={i} className={history.location.pathname === item.url ? "menuItem _selected" : "menuItem"}>
                {item.title}
              </Link>
            })
          }

          <div className="menuItem" onClick={() => setCreateMarketOpened(true)}>
            Create Market
          </div>
          {/* <div className="moreButton">
            <div onClick={() => setMoreDropdown(() => !moreDropdown)} className={moreDropdown ? "menuItem  _selected disable-select" : "menuItem disable-select"}>
              <p>More</p>
              <img src={DropdownIcon}/>
            </div>
            {
              moreDropdown &&
              <div className="moreDropdown">
                <a href={"https://prism.ag/statistics"} className="menuContainer menuItem">
                  Statistics
                </a>
                <a href={"https://docs.prism.ag/"} className="menuContainer menuItem">
                  Documentation
                </a>
              </div>
            }
          </div> */}
          
        </div>
 
      </div>

      <div className="side">
        <a href="https://prism.ag" className="menuItem">Switch to Swap</a>
        <hr className="separator" style={{marginLeft:"0.6rem", marginRight:"0.6rem"}}/>
        {/* <ButtonSelector 
          items={[
            <div className="dexChoice">
              <img style={{borderRadius:"50%"}} src={PhoenixImage} width="16" height="16" alt="Phoenix"/>
              <p className="dexName">Phoenix</p>
            </div>,
            <div className="dexChoice">
              <img style={{borderRadius:"50%"}} src={OpenbookImage} width="16" height="16" alt="Openbook"/>
              <p className="dexName">Openbook</p>
            </div>
          ]}
          onSelect={(id) => switchTheme(id)}
          selected={themeWheel.indexOf(state.theme)}/> */}
        <hr className="separator" style={{marginLeft:"0.6rem", marginRight:"0.6rem"}}/>
        <ButtonSelector 
          items={[<LightIcon fill="var(--gray500)"/>,
            <DarkIcon fill="var(--gray500)"/>, 
            <TerminalIcon fill="var(--gray500)"/>
          ]}
          onSelect={(id) => switchTheme(id)}
          selected={themeWheel.indexOf(state.theme)}/>
        <hr className="separator" style={{marginLeft:"0.6rem"}}/>
        { !state.walletConnected ?
          <ConnectWallet/>
          :
          <WalletSettings/>
        }
      </div>
      
    </div>
    <CreateMarketPopup open={createMarketOpened} onClose={() => setCreateMarketOpened(false)}/>
  </>

// Mobile Version
if(width <= 900)
return <>
  <div className="headerWrapper">
    <div className="side">
      <Logo className="logo" fill={"var(--gray900"} height={16}/>
    </div>

    <div className="side">
      <hr className="separator"/>
      { !state.walletConnected ?
        <ConnectWallet/>
        :
        <WalletSettings/>
      }
      <hr className="separator"/>
      { burgerMenuOpened ?
        <CloseIcon onClick={() => setBurgerMenuOpened(() => !burgerMenuOpened)} className="menuBurger" stroke={"var(--gray700)"}/>
        :
        <MenuIcon onClick={() => setBurgerMenuOpened(() => !burgerMenuOpened)} className="menuBurger" stroke={"var(--gray700)"}/>
      }
    </div>
    
  </div>
  { burgerMenuOpened &&
    <div className="burgerMenu">
      {/* {
        menuItems.map((item, i) => {
          return <Link to={item.url} key={i} className={history.location.pathname === item.url ? "menuItem _selected" : "menuItem"}>
            {item.title}
          </Link>
        })
      }
      <Link to={"/"} className="menuContainer menuItem">
        Statistics
      </Link>
      <Link to={"/"} className="menuContainer menuItem">
        Documentation
      </Link> */}
      <a href="https://prism.ag" className="menuItem">Switch to Simple</a>
    </div>
  }
</>
}

export default React.memo(Header);
